import BreakPointConfig from "components/Stacker/constants/breakpoints"
import { useI18nContext } from "i18n/i18n-react"
import PropTypes from "prop-types"
import React, { useContext } from "react"
import MediaQuery from "react-responsive"
import { StackerContext } from "components/DYStackers/StackerContext"
import iconHelp from "assets/icons/icon-help.svg"
import iconShare from "assets/icons/icon-share.svg"
import { InlineSVGIcon } from "components/Stacker/SvgIcon"
import { AEM_ASSETS } from "components/Stacker/AEMConstants"
import mensIconArrowLeft from "../../../../../../assets/icons/men-s-icon-arrow-left.svg"
import "./AmuletStackerHelpControls.scss"

export default function AmuletStackerHelpControls(props) {
  const { onChangeChainClick, onHelpClick, onShareClick } = props
  const { LL } = useI18nContext()
  const stackerContext = useContext(StackerContext)
  const backArrow =
    stackerContext.gender == "men"
      ? mensIconArrowLeft
      : `${AEM_ASSETS}/temp/icons/icon-arrow-back.svg`

  return (
    <React.Fragment>
      <MediaQuery query={BreakPointConfig.IS_MOBILE}>
        <div className="help-controls-mobile w-100">
          <button
            className="btn btn-icon icon icon-share d-lg-none"
            onClick={onShareClick}
          >
            <InlineSVGIcon
              style={{
                display: "inline-block",
                height: 11,
                width: 11,
                marginLeft: -6,
                top: -5,
                position: "relative",
              }}
              alt={LL.bracelets.share()}
              className={""}
              iconSvgText={iconShare}
            />
          </button>

          <button
            className="btn btn-icon icon icon-help d-lg-none"
            onClick={onHelpClick}
          >
            <InlineSVGIcon
              style={{
                display: "inline-block",
                height: 11,
                width: 11,
                marginLeft: -5,
                top: -5,
                position: "relative",
              }}
              signal={true}
              alt={LL.amulets.help()}
              className={""}
              iconSvgText={iconHelp}
            />
          </button>

          <button
            className="btn btn-icon icon icon-back icon-change-chain d-lg-none"
            onClick={onChangeChainClick}
          >
            <img
              alt={LL.bracelets.addMore()}
              className="d-inline mr-1 amulet-back-arrow"
              height="11"
              width="11"
              src={backArrow}
            />
          </button>
        </div>
      </MediaQuery>

      <MediaQuery query={BreakPointConfig.IS_DESKTOP}>
        <div className="help-controls">
          <button
            className="btn btn-text text-share d-inline"
            onClick={onShareClick}
          >
            {LL.amulets.share()}
          </button>
          <span className="text-black">|</span>
          <button
            className="btn btn-text text-help d-inline"
            onClick={onHelpClick}
          >
            {LL.amulets.help()}
          </button>
        </div>
      </MediaQuery>
    </React.Fragment>
  )
}

AmuletStackerHelpControls.propTypes = {
  onChangeChainClick: PropTypes.func.isRequired,
  onHelpClick: PropTypes.func.isRequired,
  onShareClick: PropTypes.func,
}
